/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VlcMain.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React, { useEffect, useRef, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { HandleApiActions, labCar } from "../../../../redux/actions";

import { shallowEqual, useDispatch, useSelector } from "react-redux";
import customConsole from "../../../../config/customConsole";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import VlcEEComponents from "../../../../pages/labcar/EEComponents";
import selectVariantAction from "../../../../redux/actions/selectVariant";


function VlcMain({
  selectedSingleVariantDetails,
  setSelectedSingleVariantDetails,
  projectOptionsList,
  setProjectOptionsList,
  selectedVariant,
  setSelectedVariant,
  selectedProject,
  setSelectedProject,
  selectedProjectDetails,
  selectedVariantDetails,
  variantOptionList,
  projectDetails,
  projectId,
  setSelectedVehicleView,
  selectedVehicleView,
  selectedEEComponentDetails,
  setSelectedEEComponentDetails,
  selectedZone,
  setSelectedZone,
  selectedZoneDetails,
  setSelectedZoneDetails,
  getApiDataforFilter,
  setGetApiDataforFilter,
  filterData,
  zoneEECountList,
  setZoneEECountList,
  setProjectEECount,
  getZoneEECountList,
  viewArchived,
  selectedArchivedEEs,
  setSelectedArchivedEEs,
  selectedArchivedSWMs,
  setSelectedArchivedSWMs,
  clearAllCounter,
  retrievalRefreshCounter,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const settingsVehicleSystemsDetails = useSelector(
    (state) => state.vehicleSystemsReducer,
  );

  const { eeComponentsList } = useSelector(
    (state) => state.labCarReducer,
    shallowEqual,
  );

  const [isLinkSoftwareModulesScreen, setIsLinkSoftwareModulesScreen] = useState(false);

  useEffect(() => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId =
      selectedSingleVariantDetails?.variant_id || selectedVariant?.variant_id;
    if (projectId && variantId) {
      setSelectedVehicleView("ECU");
    }
  }, [
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
    selectedVariant?.variant_id,
    setSelectedVehicleView,
  ]);

  const [vsAndVCOptionsList, setVSAndVCOptionsList] = useState([]);

  const [zoneEEList, setZoneEEList] = useState([]);
  const [centralizedEEList, setCentralizedEEList] = useState([]);

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const selectedEEIdFromUrl = queryParams.get("ee_id");
  const selectedPageFromUrl = queryParams.get("page");
  const selectedZoneFromUrl = queryParams.get("selectedZone");
  const zonePositionFromUrl = queryParams.get("zonePosition");
  const actionModeFromUrl = queryParams.get("actionMode");
  const selectedSWMIdFromUrl = queryParams.get("swm_id");
  const isRedirectedEEAction =
    actionModeFromUrl === "eeComponentAction" && Boolean(selectedEEIdFromUrl);
  const isRedirectedSWMAction =
    actionModeFromUrl === "swmAction" && Boolean(selectedSWMIdFromUrl);
  const queryLinkSoftwareModulesScreen = queryParams.get(
    "linkSoftwareModulesScreen",
  );

  const [selectedSearchField, setSelectedSearchField] =
    useState("supplier_name");
  const [searchFieldValue, setSearchFieldValue] = useState("");

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [totalEECount, setTotalEECount] = useState(0);

  const [swmPage, setSwmPage] = useState(1);
  const [swmRowsPerPage, setSwmRowsPerPage] = useState(25);
  const [hasMore, setHasMore] = useState(false);
  const [swmHasMore, setSwmHasMore] = useState(false);
  const [totalSWMCount, setTotalSWMCount] = useState(0);

  useEffect(() => {
    const pageFromUrl = Number(selectedPageFromUrl);
    if (pageFromUrl > 0 && page !== pageFromUrl) {
      setPage(pageFromUrl);
    }
  }, [selectedPageFromUrl, page, setPage]);

  useEffect(() => {
    if (queryLinkSoftwareModulesScreen && !isLinkSoftwareModulesScreen) {
      setIsLinkSoftwareModulesScreen(true);
    }
  }, [queryLinkSoftwareModulesScreen, isLinkSoftwareModulesScreen]);

  const prevProjectIdRef = useRef();
  useEffect(() => {
    const projectId = selectedProject?.project_id;

    if (prevProjectIdRef.current === undefined) {
      prevProjectIdRef.current = projectId;
      return;
    }

    if (prevProjectIdRef.current !== projectId) {
      prevProjectIdRef.current = projectId;
      setSelectedZone(null);
      setSelectedZoneDetails(null);
      setZoneEEList([]);
      setCentralizedEEList([]);
      setSelectedSingleVariantDetails([]);
    }
  }, [
    selectedProject?.project_id,
    setSelectedSingleVariantDetails,
    setSelectedZone,
    setSelectedZoneDetails,
  ]);





  const prevProjectDetailsIdRef = useRef();
  useEffect(() => {
    const projectId = selectedProjectDetails?.project_id;
    if (prevProjectDetailsIdRef.current === undefined) {
      prevProjectDetailsIdRef.current = projectId;
      return;
    }
    if (prevProjectDetailsIdRef.current !== projectId) {
      prevProjectDetailsIdRef.current = projectId;
      dispatch(selectVariantAction(null));
    }
  }, [selectedProjectDetails?.project_id, dispatch]);



  useEffect(() => {
    if (
      selectedZone?.zone_position_name &&
      selectedProjectDetails?.project_zones
    ) {
      let filteredSelectedZoneDetails =
        selectedProjectDetails?.project_zones?.find(
          (el) => el?.zone_name === selectedZone?.zone_position_name,
        );
      setSelectedZoneDetails(filteredSelectedZoneDetails);
    }
  }, [selectedZone, selectedProjectDetails, setSelectedZoneDetails]);

  const buildEEFetchParams = ({
    projectId,
    variantId,
    isZonal,
    zonePosition,
    eeId,
    searchValue,
    searchField,
    pageNumber,
    pageSize,
    viewArchived,
  }) => {
    if (!projectId || !variantId) return null;
    if (isZonal && (zonePosition === null || zonePosition === undefined))
      return null;

    return {
      project_id: projectId,
      variant_id: Number(variantId),
      ...(isZonal && { zone_position: zonePosition }),
      ...(eeId && { ee_id: Number(eeId) }),
      ...(searchValue && { [searchField]: searchValue }),
      page_number: pageNumber,
      pageSize: pageSize,
      page_size: pageSize,
      archive: !!viewArchived,
    };
  };

  const updateEEListState = (data, isZonal) => {
    const list = Array.isArray(data) ? data : [];
    if (isZonal) {
      setZoneEEList(list);
    } else {
      setCentralizedEEList(list);
    }
  };

  const getEEComponentsList = useCallback((options = {}) => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    const isZonal = !!selectedProjectDetails?.is_zonal;
    const effectiveZoneDetails =
      selectedZoneDetails ||
      (isZonal && selectedZone?.zone_position_name && selectedProjectDetails?.project_zones
        ? selectedProjectDetails.project_zones.find(
            (el) => el?.zone_name === selectedZone?.zone_position_name,
          )
        : null) ||
      (isZonal ? selectedProjectDetails?.project_zones?.[0] : null);
    const zonePosition = isZonal ? effectiveZoneDetails?.position : undefined;
    const isRedirectedActionZone =
      !isZonal ||
      String(effectiveZoneDetails?.position) === String(zonePositionFromUrl) ||
      effectiveZoneDetails?.zone_name === selectedZoneFromUrl;
    const redirectedActionEEId =
      (isRedirectedEEAction || isRedirectedSWMAction) && isRedirectedActionZone
        ? selectedEEIdFromUrl
        : null;

    const archiveOption =
      typeof options?.archive === "boolean" ? options.archive : viewArchived;

    const params = buildEEFetchParams({
      projectId,
      variantId,
      isZonal,
      zonePosition,
      eeId: redirectedActionEEId,
      searchValue: searchFieldValue,
      searchField: selectedSearchField,
      pageNumber: page,
      pageSize: rowsPerPage,
      viewArchived: archiveOption,
    });

    if (!params) return;

    dispatch(
      HandleApiActions({
        ...labCar.get_ee_components,
        params,
        show_toast: false,
      }),
    ).then((eeResponse) => {
      if (!eeResponse) return;

      setTotalEECount(eeResponse.total_count || 0);

      if (eeResponse?.error) {
        updateEEListState([], isZonal);
        return;
      }

      setHasMore(eeResponse.data?.length >= rowsPerPage);
      updateEEListState(eeResponse?.data, isZonal);

      const redirectedActionCompleted =
        isRedirectedEEAction &&
        redirectedActionEEId &&
        eeResponse?.data?.length === 1 &&
        ![4, 5].includes(Number(eeResponse.data[0]?.action_type));

      if (redirectedActionCompleted) {
        const paramsToClear = new URLSearchParams(location.search);
        paramsToClear.delete("ee_id");
        paramsToClear.delete("actionMode");
        paramsToClear.delete("page");
        navigate(`${location.pathname}?${paramsToClear.toString()}`, {
          replace: true,
        });
      }
    });
  }, [
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
    selectedProjectDetails?.is_zonal,
    selectedProjectDetails?.project_zones,
    selectedZoneDetails,
    selectedZone?.zone_position_name,
    page,
    rowsPerPage,
    searchFieldValue,
    selectedSearchField,
    selectedEEIdFromUrl,
    selectedZoneFromUrl,
    zonePositionFromUrl,
    viewArchived,
    isRedirectedEEAction,
    isRedirectedSWMAction,
    location.pathname,
    location.search,
    navigate,
    dispatch,
  ]);

  const lastEEFetchKeyRef = useRef("");
  useEffect(() => {
    if (selectedVehicleView === "ECU") {
      lastEEFetchKeyRef.current = "";
    }
  }, [selectedVehicleView]);
  useEffect(() => {
    if (!actionModeFromUrl) {
      lastEEFetchKeyRef.current = "";
    }
  }, [actionModeFromUrl]);
  useEffect(() => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    const isZonal = !!selectedProjectDetails?.is_zonal;
    let effectiveZonePosition;
    if (isZonal) {
      const matchedZonePosition =
        selectedZone?.zone_position_name && selectedProjectDetails?.project_zones
          ? selectedProjectDetails.project_zones.find(
              (el) => el?.zone_name === selectedZone?.zone_position_name,
            )?.position
          : undefined;

      effectiveZonePosition =
        selectedZoneDetails?.position ??
        matchedZonePosition ??
        selectedProjectDetails?.project_zones?.[0]?.position;
    }

    let zoneKey = "CENTRAL";
    if (isZonal) {
      zoneKey =
        effectiveZonePosition !== undefined && effectiveZonePosition !== null
          ? String(effectiveZonePosition)
          : "";
    }
    const key = [
      projectId,
      variantId,
      zoneKey,
      page,
      rowsPerPage,
      selectedSearchField,
      searchFieldValue,
      selectedEEIdFromUrl,
      selectedSWMIdFromUrl,
      actionModeFromUrl,
      viewArchived,
    ].join("|");

    if (
      !projectId ||
      !variantId ||
      (isZonal && (effectiveZonePosition === null || effectiveZonePosition === undefined))
    )
      return;
    const variantProjectId = selectedSingleVariantDetails?.project_id;
    if (variantProjectId && Number(variantProjectId) !== Number(projectId)) {
      return;
    }
    if (lastEEFetchKeyRef.current === key) return;
    lastEEFetchKeyRef.current = key;

    getEEComponentsList();
  }, [
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
    selectedSingleVariantDetails?.project_id,
    selectedProjectDetails?.is_zonal,
    selectedProjectDetails?.project_zones,
    selectedZoneDetails,
    selectedZoneDetails?.position,
    selectedZone?.zone_position_name,
    page,
    rowsPerPage,
    selectedSearchField,
    searchFieldValue,
    selectedEEIdFromUrl,
    selectedSWMIdFromUrl,
    actionModeFromUrl,
    viewArchived,
    getEEComponentsList,
  ]);

  useEffect(() => {
    if (retrievalRefreshCounter > 0) {
      lastEEFetchKeyRef.current = "";
      getEEComponentsList();
    }
  }, [retrievalRefreshCounter, getEEComponentsList]);

  useEffect(() => {
    const hasVariant = Boolean(selectedSingleVariantDetails?.variant_id);
    if (!selectedProjectDetails) return;
    if (!hasVariant) {
      setZoneEEList([]);
      setCentralizedEEList([]);
      setTotalEECount(0);
      setTotalSWMCount(0);
      return;
    }

    if (eeComponentsList) {
      if (selectedProjectDetails.is_zonal) {
        setZoneEEList(eeComponentsList);
      } else {
        setCentralizedEEList(eeComponentsList);
      }
    }
  }, [
    eeComponentsList,
    selectedProjectDetails,
    selectedSingleVariantDetails?.variant_id,
  ]);



  useEffect(() => {
    let filteredVehicleSystemOptionsList = Array.isArray(
      settingsVehicleSystemsDetails?.vehicleSystemsDetails?.data,
    )
      ? settingsVehicleSystemsDetails.vehicleSystemsDetails.data.map((vs) => ({
        value: vs?.name,
        label: vs?.name,
        vehicleComponentsOptionsList: Array.isArray(vs?.components)
          ? vs.components.map((vc) => ({
            value: vc,
            label: vc,
          }))
          : [],
      }))
      : [];

    setVSAndVCOptionsList(filteredVehicleSystemOptionsList);
  }, [settingsVehicleSystemsDetails]);

  useEffect(() => {
  }, [zoneEECountList]);
  useEffect(() => {
    customConsole("selectedZoneDetails: " + selectedZoneDetails);
    customConsole("selectedZone: " + selectedZone);
    customConsole("selectedProjectDetails: " + selectedProjectDetails);
    customConsole("zoneEEList " + zoneEEList);
    customConsole({ zoneEECountList });
    customConsole({ vsAndVCOptionsList });
  }, [
    selectedZoneDetails,
    zoneEEList,
    zoneEECountList,
    vsAndVCOptionsList,
    selectedProjectDetails,
    selectedZone,
  ]);


  const handleZoneEEAdd = ({
    variant_ids,
    save_as_draft,
    vc_id,
    assembly_number,
    supplier_name,
    version,
    summary,
    description,
    keywords,
    vehicle_systems,
    other_fields,
    attributes,
  }) => {
    if (
      selectedProjectDetails?.project_id &&
      selectedSingleVariantDetails?.variant_id
    ) {
      let currentTime = new Date().toISOString();

      return dispatch(
        HandleApiActions({
          ...labCar.add_ee_component,
          params: {
            variant_ids,
            save_as_draft,
            project_id: Number(selectedProjectDetails?.project_id),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            ...(selectedProjectDetails.is_zonal && {
              zone_position: selectedZoneDetails?.position,
            }),
            assembly_number,
            ...(supplier_name && { supplier_name }),
            vc_id: vc_id,
            version,
            ...(summary && { summary }),
            description,
            keywords,
            vehicle_systems,
            other_fields,
            current_time: currentTime,
            attributes: attributes,
          },
          show_toast: true,
        }),
      ).then((res) => {
        getEEComponentsList();
        getZoneEECountList(
          Number(selectedProjectDetails?.project_id),
          Number(selectedSingleVariantDetails?.variant_id),
        );

        return !res.error;
      });
    }

    return false;
  };

  const handleZoneEEUpdate = ({ ee_id, version, will_it_impact, reason }) => {
    if (
      selectedProjectDetails?.project_id &&
      selectedSingleVariantDetails?.variant_id
    ) {
      let currentTime = new Date().toISOString();

      customConsole({
        project_id: Number(selectedProjectDetails?.project_id),
        ee_id,
        version,
        current_time: currentTime,
      });

      dispatch(
        HandleApiActions({
          ...labCar.update_ee_component,
          params: {
            project_id: Number(selectedProjectDetails?.project_id),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            ee_id,
            version,
            will_it_impact,
            reason,
            current_time: currentTime,
          },
          show_toast: true,
        }),
      ).then(() => {
        getEEComponentsList();
      });
    }
  };

  const handleZoneEEReplace = ({
    ee_id,
    assembly_number,
    supplier_name,
    version,
    summary,
    description,
    vehicle_systems,
    other_fields,
    will_it_impact,
    reason,
  }) => {
    if (
      selectedProjectDetails?.project_id &&
      selectedSingleVariantDetails?.variant_id
    ) {
      let currentTime = new Date().toISOString();

      customConsole({
        project_id: Number(selectedProjectDetails?.project_id),
        ee_id,
        assembly_number,
        supplier_name,
        version,
        ...(summary && { summary }),
        description,
        vehicle_systems,
        other_fields,
        current_time: currentTime,
      });

      dispatch(
        HandleApiActions({
          ...labCar.replace_ee_component,
          params: {
            project_id: Number(selectedProjectDetails?.project_id),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            ee_id,
            assembly_number,
            supplier_name,
            version,
            ...(summary && { summary }),
            description,
            vehicle_systems,
            other_fields,
            reason,
            will_it_impact,
            current_time: currentTime,
          },
          show_toast: true,
        }),
      ).then(() => {
        getEEComponentsList();
      });
    }
  };

  const [eeSupplierFilter, setEESupplierFilter] = useState([]);
  const [eeAssemblyNumFilter, setEEAssemblyNumFilter] = useState([]);
  const [eeVersionFilter, setEEVersionFilter] = useState([]);
  const [eeSortField, setEESortField] = useState("assembly_number");
  const [eeSortOrder, setEESortOrder] = useState("asc");


  const handleEEClearFilters = () => {
    setPage(1);
    setEESupplierFilter([]);
    setEEAssemblyNumFilter([]);
    setEEVersionFilter([]);
    setEESortField("assembly_number");
    setEESortOrder("asc");
    setSWMNameFilter([]);
    setSWMVersionFilter([]);
    setSWMNameFilterSearch("");
    setSWMVersionFilterSearch("");
    setSWMSortField("name");
    setSWMSortOrder("asc");
  };

  const eeListToFilter = selectedProjectDetails?.is_zonal
    ? zoneEEList
    : centralizedEEList;
  const filteredEEList = eeListToFilter.filter((item) => {
    const supplierOk =
      eeSupplierFilter.length === 0 ||
      eeSupplierFilter.includes(item.supplier_name);
    const assemblyOk =
      eeAssemblyNumFilter.length === 0 ||
      eeAssemblyNumFilter.includes(item.assembly_number);
    const versionOk =
      eeVersionFilter.length === 0 || eeVersionFilter.includes(item.version);
    return supplierOk && assemblyOk && versionOk;
  });
  const sortedEEList = [...filteredEEList].sort((a, b) => {
    const field = eeSortField;
    let aVal = a[field] || "";
    let bVal = b[field] || "";
    if (!Number.isNaN(Number(aVal)) && !Number.isNaN(Number(bVal))) {
      aVal = Number(aVal);
      bVal = Number(bVal);
    }
    if (aVal < bVal) return eeSortOrder === "asc" ? -1 : 1;
    if (aVal > bVal) return eeSortOrder === "asc" ? 1 : -1;
    return 0;
  });




  const [swmNameFilter, setSWMNameFilter] = useState([]);
  const [swmVersionFilter, setSWMVersionFilter] = useState([]);
  const [swmNameFilterSearch, setSWMNameFilterSearch] = useState("");
  const [swmVersionFilterSearch, setSWMVersionFilterSearch] = useState("");
  const [swmSortField, setSWMSortField] = useState("name");
  const [swmSortOrder, setSWMSortOrder] = useState("asc");


  const { swModulesList } = useSelector(
    (state) => state.labCarReducer,
    shallowEqual,
  );

  const swmListToFilter = swModulesList || [];



  const filteredSWMList = swmListToFilter.filter((item) => {
    const nameOk =
      swmNameFilter.length === 0 || swmNameFilter.includes(item.name);
    const versionOk =
      swmVersionFilter.length === 0 || swmVersionFilter.includes(item.version);
    return nameOk && versionOk;
  });
  const sortedSWMList = [...filteredSWMList].sort((a, b) => {
    const field = swmSortField;
    let aVal = a[field] || "";
    let bVal = b[field] || "";
    if (typeof aVal === "string") aVal = aVal.toLowerCase();
    if (typeof bVal === "string") bVal = bVal.toLowerCase();
    if (aVal < bVal) return swmSortOrder === "asc" ? -1 : 1;
    if (aVal > bVal) return swmSortOrder === "asc" ? 1 : -1;
    return 0;
  });









  useEffect(() => {
    handleEEClearFilters();
  }, [
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
    selectedZoneDetails?.zone_name,
  ]);


  useEffect(() => {
    handleEEClearFilters();
  }, [selectedVehicleView]);



  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
     
      <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
        <VlcEEComponents
          getZoneEECountList={getZoneEECountList}
          variantOptionList={variantOptionList}
          selectedSingleVariantDetails={selectedSingleVariantDetails}
          heading={
            selectedProjectDetails?.is_zonal
              ? selectedZoneDetails?.zone_name
              : "Centralized"
          }
          eEComponentsList={sortedEEList}
          handleEEComponentAdd={handleZoneEEAdd}
          handleEEComponentUpdate={handleZoneEEUpdate}
          handleEEComponentReplace={handleZoneEEReplace}
          selectedProjectDetails={selectedProjectDetails}
          selectedZoneDetails={selectedZoneDetails}
          selectedZone={selectedZone}
          setIsLinkSoftwareModulesScreen={setIsLinkSoftwareModulesScreen}
          getEEComponentsList={getEEComponentsList}
          searchFieldValue={searchFieldValue}
          setSearchFieldValue={setSearchFieldValue}
          selectedSearchField={selectedSearchField}
          setSelectedSearchField={setSelectedSearchField}
          hasMore={hasMore}
          setHasMore={setHasMore}
          rowsPerPage={rowsPerPage}
          swmHasMore={swmHasMore}
          setSwmHasMore={setSwmHasMore}
          setRowsPerPage={setRowsPerPage}
          swmRowsPerPage={swmRowsPerPage}
          setSwmRowsPerPage={setSwmRowsPerPage}
          page={page}
          swmPage={swmPage}
          setPage={setPage}
          setSwmPage={setSwmPage}
          swmNameFilter={swmNameFilter}
          setSWMNameFilter={setSWMNameFilter}
          swmVersionFilter={swmVersionFilter}
          setSWMVersionFilter={setSWMVersionFilter}
          swmNameFilterSearch={swmNameFilterSearch}
          setSWMNameFilterSearch={setSWMNameFilterSearch}
          swmVersionFilterSearch={swmVersionFilterSearch}
          setSWMVersionFilterSearch={setSWMVersionFilterSearch}
          swmSortField={swmSortField}
          setSWMSortField={setSWMSortField}
          swmSortOrder={swmSortOrder}
          setSWMSortOrder={setSWMSortOrder}
          swmListToFilter={swmListToFilter}
          filteredSWMList={filteredSWMList}
          sortedSWMList={sortedSWMList}
          selectedEEComponentDetails={selectedEEComponentDetails}
          setSelectedEEComponentDetails={setSelectedEEComponentDetails}
          totalEECount={totalEECount}
          setTotalEECount={setTotalEECount}
          totalSWMCount={totalSWMCount}
          setTotalSWMCount={setTotalSWMCount}
          viewArchived={viewArchived}
          selectedArchivedEEs={selectedArchivedEEs}
          setSelectedArchivedEEs={setSelectedArchivedEEs}
          selectedArchivedSWMs={selectedArchivedSWMs}
          setSelectedArchivedSWMs={setSelectedArchivedSWMs}
          clearAllCounter={clearAllCounter}
          retrievalRefreshCounter={retrievalRefreshCounter}
        />
      </Box>

    </Box>
  );
}

VlcMain.propTypes = {
  selectedSingleVariantDetails: PropTypes.shape({
    variant_id: PropTypes.any,
    project_id: PropTypes.any,
  }),
  setSelectedSingleVariantDetails: PropTypes.func,
  projectOptionsList: PropTypes.array,
  setProjectOptionsList: PropTypes.func,
  selectedVariant: PropTypes.shape({
    variant_id: PropTypes.any,
  }),
  setSelectedVariant: PropTypes.func,
  selectedProject: PropTypes.shape({
    project_id: PropTypes.any,
  }),
  setSelectedProject: PropTypes.func,
  selectedProjectDetails: PropTypes.shape({
    project_id: PropTypes.any,
    is_zonal: PropTypes.bool,
    project_zones: PropTypes.arrayOf(PropTypes.any),
  }),
  selectedVariantDetails: PropTypes.any,
  variantOptionList: PropTypes.array,
  projectDetails: PropTypes.any,
  projectId: PropTypes.any,
  setSelectedVehicleView: PropTypes.func,
  selectedVehicleView: PropTypes.any,
  selectedEEComponentDetails: PropTypes.any,
  setSelectedEEComponentDetails: PropTypes.func,
  selectedZone: PropTypes.shape({
    zone_position_name: PropTypes.string,
  }),
  setSelectedZone: PropTypes.func,
  selectedZoneDetails: PropTypes.shape({
    position: PropTypes.any,
    zone_name: PropTypes.string,
  }),
  setSelectedZoneDetails: PropTypes.func,
  getApiDataforFilter: PropTypes.any,
  setGetApiDataforFilter: PropTypes.func,
  filterData: PropTypes.any,
  zoneEECountList: PropTypes.any,
  setZoneEECountList: PropTypes.func,
  setProjectEECount: PropTypes.func,
  getZoneEECountList: PropTypes.func,
  viewArchived: PropTypes.bool,
  selectedArchivedEEs: PropTypes.arrayOf(PropTypes.any),
  setSelectedArchivedEEs: PropTypes.func,
  selectedArchivedSWMs: PropTypes.arrayOf(PropTypes.any),
  setSelectedArchivedSWMs: PropTypes.func,
  clearAllCounter: PropTypes.number,
  retrievalRefreshCounter: PropTypes.number,
};

export default React.memo(VlcMain);
